module.exports = __webpack_public_path__ + "img/menu-show.835bb6ff.svg";